











import Vue from "vue";
import BaseComponent from "@/asdcom/BaseComponent";
// import MainTemplate from "@/components/vcponlineok/main-template.vue";
import Component from "vue-class-component";

@Component({
  components: {
    //MainTemplate
  }
})
export default class AccountView extends BaseComponent {}
